(() => {
  'use strict';

  if (window.WubCollectionShoppingFlowV24) return;

  const qs = (root, selector) => root ? root.querySelector(selector) : null;
  const getRoot = (node) => node?.closest?.('[data-wub-collection]') || null;

  function usesDrawer(root) {
    return Boolean(root && (
      window.matchMedia('(max-width: 1024px)').matches ||
      root.classList.contains('wub-collection-v2--facets-drawer')
    ));
  }

  function markDrawerDirty(root, dirty) {
    if (!root) return;
    if (dirty) root.dataset.filtersDirty = 'true';
    else root.removeAttribute('data-filters-dirty');
    qs(root, '.wub-facets__apply')?.classList.toggle('is-dirty', Boolean(dirty));
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target?.matches?.('[data-wub-filter-input]')) return;
    const root = getRoot(target);
    if (!root || !usesDrawer(root)) return;

    // Drawer filters are intentionally multi-select. Prevent the canonical
    // collection listener from auto-submitting until the user presses Apply.
    event.stopImmediatePropagation();
    markDrawerDirty(root, true);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-wub-filter-form]');
    if (!form) return;
    markDrawerDirty(getRoot(form), false);
  }, true);

  const api = Object.freeze({ usesDrawer, markDrawerDirty });
  window.WubCollectionShoppingFlowV21 = api;
  window.WubCollectionShoppingFlowV24 = api;
})();
